<template>
    <v-table
        class="table-data"
        fixed-header>
        <thead>
        <tr>
            <th v-for="item in headers"
            :key="item" class="text-left">
            {{item}}
            </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in sales"
          :key="item.date"
          @click="openDrawer(item)">

          <td>{{item.date }}</td>
          <td>{{intToMoney(item.cash)}}</td>
          <td>{{intToMoney(item.debit )}}</td>
          <td>{{intToMoney(item.credit )}}</td>
          <td>{{intToMoney(item.transfer) }}</td>
          <td>{{intToMoney(item.deposit) }}</td>
          <td>{{intToMoney(item.cash+item.debit+item.credit+item.transfer+item.deposit) }}</td>
          <td>{{item.cancel > 0 ? item.cancel+ 'cancelados': 'Sin cancelados' }}</td>

        </tr>
        </tbody>
    </v-table>

</template>

<script>
import moneyTransform from '@/utils/moneyTransform'
export default {
  name: 'CommerciaVueOrdersTable',
  emits: ['refreshList'],
  props: {
    sales: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      headers: ['Fecha', 'Efectivo', 'Débito', 'Crédito', 'Transferencia', 'Depósito', 'Total', 'Notas']
    }
  },

  methods: {
    intToMoney (val) { return moneyTransform.intToMoney(val) }
  }
}
</script>
